module.exports = __webpack_public_path__ + "img/Aventura.be671275.svg";